import LiveTV from '../../components/LiveTV/LiveTV'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { channel } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'
import { DEFAULT_CHANNEL } from './../../constants/LiveTV'

export default compose(
    graphql(channel, {
        name:'channel',
        options: (props) => ({
            variables: {
                slug: props.match.params.channel_slug ? props.match.params.channel_slug : DEFAULT_CHANNEL
            }
        })
    })
)(withRouter(
    connect(
        null,
        null
    )(LiveTV)
));



// WEBPACK FOOTER //
// ./src/containers/LiveTV/LiveTV.js